// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"99":"LazyGoogleOneTap","873":"LazyIdentificationForm"}[chunkId] + "." + {"99":"b370fa6a48c3745d7545","873":"c8e877797a7b2e7b5a4c"}[chunkId] + ".js";
};